import { BASE_URL } from '../configs/config';
import Auth from '../libs/auth-wrapper';
import { apiFetch } from '../libs/apiFetch';

export const runRestaurantOpenProcedure = async (rest_id: string, correlationId?: string) => {
  try {
    const idToken = await Auth.getIdToken();

    const res = await apiFetch(
      `${BASE_URL}runRestaurantOpenProcedure?rest_id=${rest_id}`,
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
        },
      },
      correlationId
    );
    const data = await res.json();
    return data;
  } catch (error) {}
};
